import hiringInsights from "@/assets/HiringInsights.webp";
const HiringInsights = () => {
	return (
		<div
			className=" bg-white  rounded-[50px]  w-full h-[350px] mt-3"
		// data-aos="flip-left"
		>
			{/* <div className="flex justify-between items-center mb-4">
				<h3 className="text-xl font-semibold text-gray-700">Hiring Insights</h3>
				<h6 className="text-lg  text-gray-500">Coming Soon</h6>
			</div> */}
			<img src={hiringInsights} className="w-full h-full" />
			{/* {graphData ? (
	                <div className="h-[200px] w-full ">
	                    <ResponsiveBar
	                        data={starData}
	                        keys={["star"]}
	                        indexBy="starNumber"
	                        layout="vertical"
	                        margin={{ top: 5, right: 10, bottom: 20, left: 50 }}
	                        padding={0.2}
	                        colors={({ index }) => colors[index]} // Assign different colors for each bar
	                        borderRadius={10} // Rounded corners for the bars
	                        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
	                        axisTop={null}
	                        axisRight={null}
	                        axisBottom={{
	                            tickSize: 0,
	                            tickPadding: 5,
	                            tickRotation: 0,
	                            legend: "",
	                            legendPosition: "middle",
	                            legendOffset: 32,
	                        }}
	                        axisLeft={{
	                            tickSize: 0,
	                            tickPadding: 10,
	                            tickRotation: 0,
	                            legend: "",
	                            legendPosition: "middle",
	                            legendOffset: -40,
	                        }}
	                        enableGridX={false} // Enable the grid for x-axis
	                        enableGridY={false} // Disable the grid for y-axis
	                        // label={(d) => d.value} // Display the value inside the bars
	                        labelTextColor="#FFFFFF" // Label color
	                        labelSkipWidth={0}
	                        labelSkipHeight={0}
	                        theme={{
	                            axis: {
	                                ticks: {
	                                    text: {
	                                        fontSize: 12,
	                                        fill: "#6B7280", // Gray text for ticks
	                                    },
	                                },
	                            },
	                            grid: {
	                                line: {
	                                    stroke: "#E5E7EB", // Light gray for grid lines
	                                    strokeWidth: 1,
	                                },
	                            },
	                        }}
	                    />
	                </div>
	            ) : (
	                <div className="p-3 text-center font-semibold text-2xl text-gray-500">
	                    No Data Found
	                </div>
	            )} */}
		</div>
	);
};

export default HiringInsights;
